module.exports = __webpack_public_path__ + "img/操作-翻译.763ab6f7.png";